import { Dock } from './../../models/Dock';
import { ModalProvider } from './../../providers/modal/modal';
import { AppFacade } from './../../facade/app.facade';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavController, ToastController, AlertController } from 'ionic-angular';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePage {

  docks$ = this.facade.docks$
  docksReserved$ = this.facade.docksReserved$
  docksFree$ = this.facade.docksFree$
  docksOccupied$ = this.facade.docksOccupied$

  constructor(
    public facade: AppFacade,
    public navCtrl: NavController,
    private modalProvider: ModalProvider,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
  ) {
  }

  openModal(dock: Dock) {
    if (dock !== null) {
      this.modalProvider.open(dock)
    }
  }

  public clearAllDocks() {
    this.alertCtrl.create({
      title: "Docks herstellen?",
      message: "Weet u zeker dat u de docks wilt herstellen en zo beschikbaar maken?",
      buttons: [
        {
          text: "Nee, annuleren",
        },
        {
          text: "Ja, herstellen",
          handler: data => {
            this.facade.clearAllDocks()
            this.toastCtrl.create({
                  message: 'Docks worden hersteld.',
                  duration: 3000,
              })
              .present();
          }
        }
      ]
    }).present()
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts